import { useBreakpointValue } from "@chakra-ui/react";
import { useMemo } from "react";

import { InfoEllipseIcon, TickIcon, WarningIcon } from "design_system/icons";
import { colors } from "src/colors";

import { ToastType, VariantToastType } from "./type";

type Props = {
  variant?: VariantToastType;
};
const useToastContent = ({ variant = "warning" }: Props) => {
  const isMobile = useBreakpointValue([true, null, false]);

  const exitIconSize = useMemo(() => (isMobile ? 30 : 40), [isMobile]);

  const { background, icon } = useMemo(() => {
    switch (variant) {
      case ToastType.success:
        return {
          background: colors.green[500],
          icon: <TickIcon color={colors.white.off} />
        };
      case ToastType.info:
        return {
          background: colors.blue[400],
          icon: <InfoEllipseIcon color={colors.white.off} />
        };
      case ToastType.error:
        return {
          background: colors.red[400],
          icon: <WarningIcon color={colors.white.off} />
        };

      default:
        return {
          background: colors.orange[400],
          icon: <WarningIcon color={colors.white.off} />
        };
    }
  }, [variant]);

  return {
    background,
    icon,
    exitIconSize
  };
};

export default useToastContent;
